export const PUZZLETAX_URL = 'https://puzzletax.pl';
export const PUZZLETAX_CONTACT_URL = `${ PUZZLETAX_URL }/kontakt`;
export const PUZZLETAX_FAQ_URL = `${ PUZZLETAX_URL }/faq`;